import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Accessibility from '@material-ui/icons/Accessibility';
import { Link } from 'react-router-dom';
import LocalOffer from '@material-ui/icons/LocalOffer';
import { connect } from 'react-redux';
import { getAllUsers } from '../../store/actions/admin/Admin';
// core components
import GridItem from '../../components/Grid/GridItem.js';
import Card from '../../components/Card/Card.js';
import CardHeader from '../../components/Card/CardHeader.js';
import CardIcon from '../../components/Card/CardIcon.js';
import CardFooter from '../../components/Card/CardFooter.js';

import styles from '../../assets/jss/material-dashboard-react/views/dashboardStyle.js';

const useStyles = makeStyles(styles);

const Vendors = (props) => {
  useEffect(() => {
    props.getAllUsers();
  }, []);

  const classes = useStyles();
  return (
    <GridItem xs={12} sm={6} md={3}>
      <Link style={{ textDecoration: 'none' }} to={'/admin/users'}>
        <Card>
          <CardHeader color="info" stats icon>
            <CardIcon color="info">
              <Accessibility />
            </CardIcon>
            <p className={classes.cardCategory}>Users</p>
            <h3 className={classes.cardTitle}>{props.allUsersCount}</h3>
          </CardHeader>
          <CardFooter stats>
            <div className={classes.stats}>
              <LocalOffer />
              More Info
            </div>
          </CardFooter>
        </Card>
      </Link>
    </GridItem>
  );
};

const mapStateWithProps = (state) => ({
  allUsers: state.admin.allUsers,
  allUsersCount: state.admin.allUsersCount
});
const mapDispatchWithProps = (dispatch) => {
  return {
    getAllUsers: () => dispatch(getAllUsers(1, 10000))
  };
};

export default connect(mapStateWithProps, mapDispatchWithProps)(Vendors);
